import { useState, useEffect } from 'react';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

export interface Country {
    id: number;
    name: string;
    iso2: string;
}

export const useCountries = () => {
    const [countries, setCountries] = useState<Country[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchCountries = async () => {
            setLoading(true);
            try {
                const httpClient = createHttpClient(apiClientWH);
                const response = await httpClient.get<any>('/countries');
                const data = Array.isArray(response) ? response : (response.data || []);
                setCountries(data.map((c: any) => ({
                    id: c.id,
                    name: c.name,
                    iso2: c.iso2
                })));
            } catch (error) {
                console.error('Error fetching countries:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCountries();
    }, []);

    return { countries, loading };
};
